export default {
  "metrics_setting_title": "指标设置",
  "metrics_setting_show_metrics": "展示指标",
  "metrics_setting_show_more_statistics": "展示更多统计",
  "metrics_setting_show_more_statistics_tips": "统计值将展示在表格末尾。",
}
